"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var checkmark = {
  before: (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: 40%;\n        height: 8%;\n        right: 55%;\n        bottom: 20%;\n        transform: rotate(45deg);\n        transform-origin: right bottom;\n    "], ["\n        width: 40%;\n        height: 8%;\n        right: 55%;\n        bottom: 20%;\n        transform: rotate(45deg);\n        transform-origin: right bottom;\n    "]))),
  after: (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: 8%;\n        height: 70%;\n        right: 54%;\n        bottom: 20%;\n        transform: rotate(35deg);\n        transform-origin: right bottom;\n    "], ["\n        width: 8%;\n        height: 70%;\n        right: 54%;\n        bottom: 20%;\n        transform: rotate(35deg);\n        transform-origin: right bottom;\n    "])))
};
var indeterminate = {
  before: (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        width: 62%;\n        height: 2px;\n        margin: 45% 20%;\n    "], ["\n        width: 62%;\n        height: 2px;\n        margin: 45% 20%;\n    "]))),
  after: (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\n    "], ["\n\n    "])))
};
var checkedShapes = {
  checkmark: checkmark,
  indeterminate: indeterminate
};
var _default = checkedShapes;
exports.default = _default;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;